import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RegistrationService {
  registrationForm = {
    //mandatory fields:personal info
    language: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    phoneNumber: "",
    //mandatory fields: basic info
    email: "",
    income: "",
    educationLevel: "",
    race: "",
    ethnicity: "",
    //optional fields:housing info
    permanentAddress: "",
    streetAddress: "",
    //optional fields:disability,sex,medicalId
    healthInsurance: "",
    disability: "",
    sex: "",
    medicalId: "",
    servedInArmy: "",
  };

  isRegFormSubmitted = new Subject();
  _isRegFormSubmitted = this.isRegFormSubmitted.asObservable();
  constructor() {
    this.isRegFormSubmitted.next(false);
  }
  //this function will be called when the user submits the form
  fillRegForm(formData) {
    this.registrationForm = {
      //mandatory fields:personal info
      language: formData.language || this.registrationForm.language,
      firstName: formData.firstName || this.registrationForm.firstName,
      lastName: formData.lastName || this.registrationForm.lastName,
      dateOfBirth: formData.dateOfBirth || this.registrationForm.dateOfBirth,
      phoneNumber: formData.phoneNumber || this.registrationForm.phoneNumber,
      //mandatory fields: basic info
      email: formData.email || this.registrationForm.email,
      income: formData.income || this.registrationForm.income,
      educationLevel:
        formData.educationLevel || this.registrationForm.educationLevel,
      race: formData.race || this.registrationForm.race,
      ethnicity: formData.ethnicity || this.registrationForm.ethnicity,
      //optional fields:housing info
      permanentAddress:
        formData.permanentAddress || this.registrationForm.permanentAddress,
      streetAddress:
        formData.streetAddress || this.registrationForm.streetAddress,
      //optional fields:healthInsurance,disability,sex,medicalId
      healthInsurance:
        formData.healthInsurance || this.registrationForm.healthInsurance,
      disability: formData.disability || this.registrationForm.disability,
      sex: formData.sex || this.registrationForm.sex,
      medicalId: formData.medicalId || this.registrationForm.medicalId,
      servedInArmy: formData.servedInArmy || this.registrationForm.servedInArmy,
    };
    console.log({
      formContentFromService: this.registrationForm,
    });
    this.isRegFormSubmitted.next(false); //to hide the form
  }

  //this function will be called after a successful submission to reset the form
  resetRegForm() {
    this.registrationForm = {
      //mandatory fields:personal info
      language: "",
      firstName: "",
      lastName: "",
      dateOfBirth: "",
      phoneNumber: "",
      //mandatory fields: basic info
      email: "",
      income: "",
      educationLevel: "",
      race: "",
      ethnicity: "",
      //optional fields:housing info
      permanentAddress: "N.A",
      streetAddress: "N.A",
      //optional fields:healthInsurance,disability,sex,medicalId,servedInArmy
      healthInsurance: "N.A",
      disability: "N.A",
      sex: "N.A",
      medicalId: "N.A",
      servedInArmy: "N.A",
    };
  }

  //this function will be called when the user is already registerd in the database OR when the user submits the form
  showRegForm() {
    this.isRegFormSubmitted.next(true); //to show the form
  }

  //to validate medical id:
  validateMedicalId(medicalId) {
    let regexCondition = /^\+?[0-9]{14}$/;
    console.log("regexCondition.test(medicalId);",regexCondition.test(medicalId));
    
    return regexCondition.test(medicalId);
  }
}
